import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./v2/App";
// import reportWebVitals from "./v2/reportWebVitals";
import "react-phone-number-input/style.css";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/styles";

import Landing from './v2/features/auth/pages/Landing';
import AccessDenied from './v2/features/auth/pages/AccessDenied';
import InsufficientPermissions from './v2/features/auth/pages/InsufficientPermissions';
import Callback from './v2/features/auth/pages/Callback';
import { AuthProvider } from './v2/contexts/AuthProvider';

import { loadConfig, Config } from "./v2/Config";
import { setOrvalBaseURL } from "@scoutus/sports-metrics";
import { ProtectedRoute } from "./v2/components";

const startApp = async () => {
  // Load runtime config first
  await loadConfig();
  const apiBaseUrl = Config.API_BASE_URL;
  if (typeof apiBaseUrl === "string" && apiBaseUrl.length > 0) {
    setOrvalBaseURL(apiBaseUrl);
  }

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Auth0 callback route */}
          <Route path="/callback" element={<Callback />} />

          {/* Public routes - no authentication required */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          {/* Access Control Routes */}
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/insufficient-permissions" element={<InsufficientPermissions />} />

          {/* Legacy absolute path from header before /v2 prefix fix */}
          <Route
            path="/manage-profile"
            element={<Navigate to="/v2/manage-profile" replace />}
          />

          {/* All v2 routes handled by the v2 app */}
          <Route path="/v2/*" element={<ProtectedRoute><App /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  // reportWebVitals(); 
}

// Start the app
startApp().catch(console.error);
